import { Box, Divider, FormLabel, Stack, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SubSection, Switch, useLocalization } from '@ui-framework/index';
import { forwardRef, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import NonRecurringDurationAndOptions from './nonrecurring/NonRecurringDurationAndOptions';
import RecurringOptions from './recurring/RecurringOptions';
import { NON_RECURRING_DURATION } from '../../../utils/constants';

const RecurringSpecialSchedule = forwardRef((props, ref) => {
  const theme = useTheme();
  const { formatMessage } = useLocalization();
  const { control, setValue, clearErrors } = useFormContext();
  const recurring = useWatch({ control, name: props?.name });
  const recurrenceFrequency = useWatch({
    control,
    name: 'recurrenceFrequency',
  });
  const recurringEndDateOptions = useWatch({
    control,
    name: 'recurringEndDateOptions',
  });

  // Reset recurrence pattern/duration correctly when you switch between recurring or non-recurring
  useEffect(() => {
    if (recurring) {
      if (
        !['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'].includes(recurrenceFrequency)
      ) {
        setValue('recurrenceFrequency', 'DAILY');
      }
      if (recurringEndDateOptions === 'NO_END_DATE') {
        clearErrors('endDate');
      }
    } else if (
      !NON_RECURRING_DURATION(formatMessage).find(
        d => d.value === recurrenceFrequency,
      )
    ) {
      setValue('recurrenceFrequency', 'SINGLE');
    }
  }, [recurring]);

  return (
    <Box>
      <Switch {...props} ref={ref} />
      <SubSection sx={{ mt: 2 }}>
        <Stack spacing={2}>
          <FormLabel sx={{ color: theme.palette.tertiary.main }}>
            <FormattedMessage
              id="OPTIONS_FOR_RECURRINGTYPE"
              defaultMessage="Options for {recurringType}"
              values={{
                recurringType: recurring ? 'Recurring' : 'Non-Recurring',
              }}
            />
            <Divider sx={{ mt: 1 }} />
          </FormLabel>

          {!recurring ? (
            <NonRecurringDurationAndOptions name="recurrenceFrequency" />
          ) : (
            <RecurringOptions />
          )}
        </Stack>
      </SubSection>
    </Box>
  );
});

export default RecurringSpecialSchedule;
